import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom'
import MainLayout from '../pages/MainLayout'
import Login from '../pages/login'
import WordCloud from '../pages/wordcloud'
import ChineseSeg from '../pages/chinese-seg'
import Sentiment from '../pages/sentiment'
import EssayCorrection from '../pages/english-correction'
import GenerateAccount from '../pages/generate-account'

export const routes = [
    {
        path: '/',
        element: <Navigate to="/wordcloud" replace />,
    },
    {
        path: '/login',
        Component: Login,
    },
    {
        path: '/',
        Component: MainLayout,
        children: [
            {
                path: 'wordcloud',
                pathName: '词云生成',
                Component: WordCloud,
            },
            {
                path: 'chinese-seg',
                pathName: '中文分词',
                Component: ChineseSeg,
            },
            {
                path: 'sentiment',
                pathName: '评论分析',
                Component: Sentiment,
            },
            {
                path: 'english-correction',
                pathName: '英语作文批改',
                Component: EssayCorrection,
            },
            {
                path: 'generate-account',
                pathName: '生成账号',
                Component: GenerateAccount,
            },
        ],
    },
]

export default createBrowserRouter(routes)
